var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.provinces)?_c('w-autocomplete',_vm._g(_vm._b({attrs:{"name":"canada-provinces-selector","items":_vm.provinces,"placeholder":_vm.l.t('app.province', 'Province'),"autocomplete":"new-password","hide-details":"auto","data-test-id":"canada-provinces-selector"}},'w-autocomplete',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }